import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

const CounterPage = () => {
  const [title, setTitle] = useState('');
  const [value, setValue] = useState('');
  const [counterList, setCounterList] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchCounters();
  }, []);

  const fetchCounters = async () => {
    try {
      const res = await axios.get(`${baseurl}/admin/getCounters`);
      setCounterList(res.data);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch counters", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !value) {
      Swal.fire("Error", "All fields required", "warning");
      return;
    }

    const payload = {
      title: title,
      value: value
    };

    try {
      if (editId) {
        //  UPDATE
        await axios.put(`${baseurl}/admin/updateCounter/${editId}`, payload);
        Swal.fire("Updated!", "Counter updated", "success");
      } else {
        //  ADD
        await axios.post(`${baseurl}/admin/addCounter`, payload);
        Swal.fire("Added!", "Counter added", "success");
      }

      setTitle('');
      setValue('');
      setEditId(null);
      fetchCounters();

    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Operation failed", "error");
    }
  };

  const handleEdit = (item) => {
    setTitle(item.title);
    setValue(item.value);
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true
    });

    if (confirm.isConfirmed) {
      try {
        await axios.put(`${baseurl}/admin/deleteCounter/${id}`);
        Swal.fire("Deleted!", "Counter removed", "success");
        fetchCounters();
      } catch (err) {
        Swal.fire("Error", "Delete failed", "error");
      }
    }
  };

  return (
    <div className="content container-fluid">
      <div className="profile-section">
      <div className="container mt-4">

        <h3>Manage Counters</h3>
        <div className='row'>
        {/* ✅ FORM */}
        <form className="row g-3" onSubmit={handleSubmit}>
          <div className='col-md-3'>
            <input
              type="text"
              value={title}
              placeholder="Title (e.g. Total Members)"
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className='col-md-3'>
          <input
            type="text"
            value={value}
            placeholder="Value (e.g. 145000+)"
            onChange={(e) => setValue(e.target.value)}
          />
          </div>
          <div className='col-md-3'>
          <button type="submit">
            {editId ? "Update" : "Add"}
          </button>
          </div>
        </form>
      </div>
        <hr />

        {/* ✅ TABLE */}
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Value</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {counterList.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.title}</td>
                <td>{item.value}</td>
                <td>
                  <button onClick={() => handleEdit(item)}>Edit</button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
        </div>
      </div>
    </div>
  );
};

export default CounterPage; 